export const gridProps = ['xs', 'sm', 'md', 'lg', 'xl', 'xsOffset', 'smOffset', 'mdOffset', 'lgOffset', 'xlOffset'];

export const PAGES_GENERATOR = {
    EDIT_AGENT_PROFILE: function (loginId?: string): string {
        return `/agent/${loginId?.toLowerCase() || ':loginId'}/edit`;
    }
}

export const PAGES = {
    HOME: '/',
    HOME_WITH_LANG: '/en',
    LOGIN: '/login',
    FORGOT_USERNAME: 'forgot-username',
    FORGOT_PASSWORD: 'forgot-password',
    RESET_PASSWORD: 'reset-password',
    MY_PROFILE: '/me',
    EDIT_PROFILE: '/edit-profile',
    AGENCY_COMMISSIONS: '/agency/commissions',
    AGENCY_VIEW: '/agency/view',
    ADD_AGENT_PROFILE: '/agent/add',
    POST_LOGIN: '/post-login',
    MANAGE_AGENTS: '/agent/manage',
    PENDING_REQUESTS: '/agent/pending-requests',
    VIEW_TRAVEL_AGENT_FINDER: '/view-ta-finder',
    EDIT_TRAVEL_AGENT_FINDER: '/edit-ta-finder',
    PRODUCT_FILES: '/product-files',
    ACCESS_DENIED: '/403',
    EDIT_AGENT_PROFILE: PAGES_GENERATOR.EDIT_AGENT_PROFILE()
};

export const LOGIN_CONSTANTS = {
    RETURN_URL_PARAM: 'returnurl',
    DEFAULT_RETURN_URL: '/',
};

export const knownPages = Object.values(PAGES);

export const TARGET = {
    SELF: '_self',
    BLANK: '_blank'
};